export default ($) => {

    if ( 'undefined' !== typeof Swiper ) {

        const swiper = new Swiper('.swiper-dealer', {
            slidesPerView: 2,
            speed: 400,
            spaceBetween: 10,
            loop: true,
            navigation: {
                nextEl: '.swiper-object-dealer .swiper-button-next',
                prevEl: '.swiper-object-dealer .swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                1200: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
            },
        });
    }

    $('.dealer-about-carousel img').on("click", function () {
        $('#meatModal #meatModalImg').remove();
        $('#meatModal .embed-responsive').remove();
        if($(this).data('img') !== undefined){
            var img = ' <img src="' + $(this).data('img') + '" id="meatModalImg" width="100%">'
            $('#meatModal .modal-body').append(img);
        }
        if($(this).data('video') !== undefined){
            var video = '<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="'+$(this).data('video')+'?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1" allowfullscreen></iframe></div>'
            $('#meatModal .modal-body').append(video);
        }

        $('#meatModal').modal('show');
    });

    $('#meatModal .close').on("click", function () {
        $('#meatModal').modal('hide');
    });

    // stop playing the youtube video when I close the modal
    $('#meatModal').on('hide.bs.modal', function (e) {
        // a poor man's stop video
        $('#meatModal #meatModalImg').remove();
        $('#meatModal .embed-responsive').remove();
    });

}
